import store from "../store";

export default async function auth({ next, router }) {
 
 
  //check sudah login?
  if (!store.getters.isAuthenticated) {
    return router.push({ name: "Login" });
  }
  //check store profile me ada atau tidak
  if(!store.getters["profile/me"] || Object.keys(store.getters["profile/me"]).length == 0){
    //minta data me ke server lalu save ke store profile me
    await store.dispatch("profile/me")
  }

  // //check store route group ada atau tidak
  // if(!store.getters["role_permission/route_group"] || Object.keys(store.getters["role_permission/route_group"]).length == 0){
    
  //   var me = await store.getters["profile/me"]
  //   var division="";
  //   if(me.role_name.division_id==2){
  //     division = "Bizdev"
  //   }
  //   else if(me.role_name.division_id==3){
  //     division = "Workshop"
  //   }
  //   console.log(me.role_name.division_id)
  //   if(me.role_name.division_id!=1){
  //     console.log("2222222222222222222222222222222")
  //     //cari index route Test dari route option routes
  //     var indexOptionTestRoute = router.options.routes.findIndex(p => p.name == division)
  //     //simpan di store route group test nya
  //     console.log(indexOptionTestRoute)
  //     await store.dispatch("role_permission/commit_route", router.options.routes[indexOptionTestRoute]);
  //   }
  // }
  

  
  // router.beforeEach((to, from, next) => {
  //   //console.log(to.name)
  //   //console.log(to.from)
  //   //console.log(next)
  //   //check nama route yang akan dituju bukan not found 
  //   console.log("ygausgd vasdh ashud")
  //   (async  () => {
  //   if(to.name!="Not Found" && to.name!='User Profile' && to.name!='Login'  && to.name!='Dashboard'){
  //     //ambil list route group dari store
  //     var listRouteGroup = await store.getters["role_permission/route_group"].children
  //     //cari index dari route group yang memiliki nama route yang sama dengan nama route yang akan dituju
  //     var indexOptionRoute = listRouteGroup.findIndex(p => p.name == to.name)
  //     // console.log(indexOptionRoute)
  //     // console.log(listRouteGroup)
      
  //     //filter route sesuai dengan nama model
  //     var filter_route = await store.getters["profile/me"].role[listRouteGroup[indexOptionRoute].group]
       
        
        
  //     //check apakah group route ada didalam role user, jika tidak ada arahkan ke route not found
  //     if(to.name.includes("List") && filter_route.menu == 0){
  //       return router.replace({ name: "Not Found" })
  //       //return router.push({ name: "Not Found" });
  //     }
  //     else if(to.name.includes("Add") && filter_route.create == 0){
  //       return router.replace({ name: "Not Found" })
  //       //return router.push({ name: "Not Found" });
  //     }
  //     else if(to.name.includes("Edit") && filter_route.edit == 0){
  //       return router.replace({ name: "Not Found" })
  //       //return router.push({ name: "Not Found" });
  //     }

  //     await store.dispatch("role_permission/commit_route_filter", filter_route)
  //   }
  //   })();
  //   return next();
  // })

  // var currentPath = window.location.pathname
  //  //console.log(currentPath)
 

  return next();
}
